export const environment = {
  env: 'dev',
  API_URL: 'https://api.dev.silberfluss.io',
  joditKey: '690BE-3BH83-AEMM5-SHNQX',
  WEBSOCKET_URL: 'wss://api.dev.silberfluss.io/ws',
  KEYCLOAK_URL: 'https://development.silberfluss.io/auth/',
  MAX_UPLOAD_SIZE_MB: 500,
  ALLOWED_FILE_FORMATS: 'application/pdf, image/png, image/jpeg',
};
